export const LANDING_PAGE_HEADING = `Manage your Bounce Back Loan`;
export const LANDING_PAGE_INFO = `The details requested in this form are only required if you choose NOT to manage your Bounce Back Loan via Online Banking `;
export const LANDING_PAGE_INSTRUCTION_HEADING1 = `Use this form to:`;
export const LANDING_PAGE_INSTRUCTIONS_LIST1 = [
  `Request repayment holiday`,
  `Request term extension`,
];
export const LANDING_PAGE_INSTRUCTION_HEADING2 = `What we require from you:`;
export const LANDING_PAGE_INSTRUCTIONS_LIST2 = [
  `Your email address and UK mobile number`,
  `The sort code and account number of your main business bank account`,
  `The balance of your Bounce Back Loan`,
  `Date of your final repayment`,
  `Details of any Pay as you Grow (PAYG) options already taken`,
];
export const LANDING_PAGE_CONCLUSION = `It should take 20 minutes or less to complete this form.`;
export const GET_STARTED_BUTTON_TEXT = `Get started`;
